import moment from "moment"

export const defaultFormat = (time: number | Date): string => {
  return moment(new Date(time).toISOString()).format("H:mm | MMM D, YYYY")
}

export const formatWithMs = (time: string | Date): string => {
  return moment(time).format("YYYY-MM-DD HH:mm:ss.SSS")
}
